import { QuestionArrowIcon } from "components/ui/icons/iaAgent/QuestionArrowIcon"
import { GeneralFeedbackForResponse } from "../../../GeneralFeedbackForResponse/GeneralFeedbackForResponse"
import { WarningMessage } from "../WarningMessage/WarningMessage"
import { CustomChatIndexingInProgress } from "../CustomChatIndexingInProgress/CustomChatIndexingInProgress"
import type { TPredefinedQuestions, TCustomChat } from "types/aiAgent.type"
import style from "./PredefinedQuestions.module.scss"
import { useEffect, useState } from "react"

const { bubble, answer, list, arrow, listItem, questionDisabled } = style

type Props = {
	predefinedQuestions: TPredefinedQuestions
	customChat: TCustomChat
	streamingInProgress: boolean
	askQuestionHandle: (e: React.MouseEvent<HTMLElement>, questionId: number, question: string) => void
}

type QuestionsType = { id: number; text: string; type: string }

export const PredefinedQuestions = ({
	predefinedQuestions,
	customChat,
	streamingInProgress,
	askQuestionHandle,
}: Props) => {
	const predefinedQuestionStatus = predefinedQuestions?.status
	const [filteredQuestions, setFilteredQuestions] = useState<QuestionsType[]>([])

	useEffect(() => {
		const filteredQuestions =
			predefinedQuestions?.questions?.filter((question) => question.type !== "bid_request") || []
		setFilteredQuestions(filteredQuestions)
	}, [predefinedQuestions])

	return (
		<>
			{predefinedQuestionStatus === "success" && filteredQuestions.length > 0 ? (
				<div className={`${bubble} ${answer}`}>
					<p>{predefinedQuestions?.status_message}</p>
					{/* Show predefined questions when the status is success and there are questions */}
					<ul className={list}>
						{filteredQuestions.map((item: QuestionsType) => (
							<li
								className={`${listItem} ${streamingInProgress ? questionDisabled : ""}`}
								key={item.id}
								onClick={(e) => askQuestionHandle(e, item.id, item.text)}
							>
								<div className={arrow}>
									<QuestionArrowIcon />
								</div>
								<span>{item.text}</span>
							</li>
						))}
					</ul>

					{/* Show feedback when the status is not success */}
					{predefinedQuestionStatus !== "success" ? <GeneralFeedbackForResponse /> : null}
				</div>
			) : (
				<WarningMessage text={predefinedQuestions?.status_message} status={predefinedQuestions?.status} />
			)}

			{/* Show warning message if custom chat is not successful or ongoing */}
			{customChat?.status !== "success" && customChat?.status !== "ongoing" ? (
				<WarningMessage text={customChat?.status_message} status={customChat?.status} />
			) : null}

			{/* Show indexing in progress component if custom chat is ongoing */}
			{customChat?.status === "ongoing" ? <CustomChatIndexingInProgress text={customChat?.status_message} /> : null}
		</>
	)
}
